import en from './en'

const locales = [en]

export default locales
